import {Component, OnInit, OnDestroy} from '@angular/core';
import {PolicyService} from '../../../../policy/services/policy.service';
import {ActivatedRoute} from '@angular/router';
import {GlobalQuestionService} from '../../../services/global-question.service';
import {Alert, pdfDocument} from '../../../../shared/utilities';
import { Browser } from '@capacitor/browser';
import { PolicyPDFScheduleDisclosureNotice } from '../../../constants';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
declare const $: any;
@Component({
    selector: 'app-doc-policy-quote',
    templateUrl: './doc-policy-quote.component.html',
    styleUrls: ['./doc-policy-quote.component.scss'],
    standalone: false
})
export class DocPolicyQuoteComponent implements OnInit, OnDestroy {

  id: string;
  policyHolderDetails: any;
  quoteDetails: any;
  brokerDetails: any;
  objectKeys = Object.keys;
  insurerDetails: any;
  quoteSummary = [];
  classTranscripts = [];
  classHeaders = [];
  benefitTranscripts = [];
  selectedSection = 'docs-details';
  printDoc = false;
  pdfDoc = false;
  hasData = false;
  premium = "";
  frequency = "mo";
  policyWordings: any;
  notes: any;
  footer: any;
  quoteDataset = [];
  policyPDFDisclosureNotice = [];
  disclosureNoticeHeaderType = PolicyPDFScheduleDisclosureNotice;
  product_id: any;
  device: any;
  previewFileUrl: SafeResourceUrl | null = null;
  private previewObjectUrl: string | null = null;
  private processingAlert: any;
  // relative (no leading slash) so it resolves against <base href> at runtime;
  // bound via [href] since a static href="..." on a stylesheet <link> is
  // treated by Angular's AOT compiler as a build-time resource path.
  printPdfCssHref: SafeResourceUrl;
  constructor(
    private route: ActivatedRoute,
    private policyService: PolicyService,
    public questionService: GlobalQuestionService,
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer
  ) {
    this.printPdfCssHref = this.sanitizer.bypassSecurityTrustResourceUrl('assets/css/print_pdf.css');
    try{
      this.device = JSON.parse(localStorage.getItem('device'));
    }
    catch{}
  }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe({
        next: value => {
          if (value?.print) {
            this.printDoc = (/true/i).test(value?.print);
          }
          if (value?.pdf) {
            this.pdfDoc = (/true/i).test(value?.pdf);
          }

          this.id = value?.quote_id;
          this.product_id = value?.product_id || null;
         if (this.id) this.getQuoteSchedule();
        }
      });
    this.route.params
      .subscribe({
        next: p => {
          this.questionService.spinner(true);
          if (p?.quoteId) {
            this.id = p?.quoteId;
            if (this.id) this.getQuoteSchedule();
          }
        }
      });
  }

  getQuoteSchedule(): void {
    this.policyService.getPolicyQuoteSchedule(this.id, this.product_id)
      .subscribe(responses => {
        if (responses?.length) {
          for (const data of responses) {
            if (data?.length) {
              
              for (const item of data) {
                if (item?.index < 5) {
                  this.quoteDataset.push(item);
                }
                
                if (item?.index === 1) {
                  this.policyHolderDetails = item;
                }
                if (item?.index === 2) {
                  this.quoteDetails = item;
                }
                if (item?.index === 3) {
                  this.brokerDetails = data.filter( b => b.index === 3 );
                }
                if (item?.index === 4) {
                  this.insurerDetails = item;
                }
                if (item?.index === 5) {
                  this.notes = data.filter( b => b.index === 5 );
                }
                if (item?.index === 6) {
                  this.quoteSummary.push(item);
                }
                if (item?.index === 7) {
                  this.policyWordings = data.filter( b => b.index === 7 );
                }
                if (item?.index === 6 && (item?.header.toLowerCase() === 'policy total')) {
                  this.policyService.setQuoteScheduleTotal(item?.premium);
                  this.premium = item?.premium;
                  if (item?.frequency) this.frequency = item?.frequency;
                }
                if (item?.index === 9) {
                  this.classTranscripts.push(item);
                  if (item?.header?.toLowerCase() === 'class header') {
                    this.classHeaders.push({
                      class_id: item?.class_id,
                      class_name: item?.class_name,
                      img_path: item?.img_path,
                      premium: item?.premium,
                      insurer_img: item?.insurer_img,
                      insurer_name: item?.insurer_name,
                      insurer_rating: item?.insurer_rating
                    });
                  }
                }
                if (item?.index === 10) {
                  this.benefitTranscripts.push(item);
                }
                if (item?.index === 11){
                  this.policyPDFDisclosureNotice.push(item);
                }
                if (item?.index === 13) {
                  this.footer = item;
                }
              }
            }
          }
          if (!this.policyHolderDetails){
              $('#error-modal').modal('show');
              $('.error-text').html('Unable to load quote details.');
              $('.error-id').html(responses[0][0].log_id)
          }
        }
        else{
          $('#error-modal').modal('show');
          $('.error-text').html('Unable to load quote details.');
        }
       
        
        setTimeout(() => {
          var sideMenuSidesheet = (function () {

            function init(args) {
    
              // close listeners...
    
              // on back button
              $(document).on('click', '.sidesheet__header-back', function () {
                closeSidesheet();
              });
    
              // on outside click
              $(document).on('click.outsidesidesheet', function (e) {
                var $target = $(e.target);
                if (!$target.closest("#sidesheet").length && !$target.closest(args.outsideClickElement).length) {
                  closeSidesheet();
                }
              });
    
            }
    
            function closeSidesheet() {
              $('#sidesheet').removeClass('is-active');
              $('body').removeClass('sidesheet-open');
            }
            function openSidesheet() {
              $('#sidesheet').addClass('is-active');
              $('body').addClass('sidesheet-open');
            }
    
            return {
              init: init,
              openSidesheet: openSidesheet,
              closeSidesheet: closeSidesheet
            }
          })();
          sideMenuSidesheet.init({ outsideClickElement: '.central-nav__burger' });
          $('.central-nav__burger').on('click', function () {
            sideMenuSidesheet.openSidesheet();
          });
          try{
            this.initDocsNav();
            //this.pdfPageSplitting();
            this.initSearch($('#search-input'));
          }
          catch (e){
            console.log(e)
          }
          // skip clearing the loader here when pdfDoc is set — keep it up through
          // preparePDF() instead of a false->true round trip that can flash the raw page
          if (!this.pdfDoc) {
            this.questionService.spinner(false);
          }
          if (this.printDoc) {
            window.print();
          }
          if (this.pdfDoc) {
            this.preparePDF();
            // Alert("Processing... please wait", 10000)
            // const element = document.getElementById('page-pdf');
            // this.questionService.pdf(element.innerHTML).subscribe(resp => {
            //   let id = resp.replace('https://vader.everything.insure/pdf/files/','');
            //   Browser.open({ url: resp.toString() });
            //   $('#close').show();
            //   setTimeout(() => { //Remove file from server after 5 secs
            //     this.questionService.pdf('',id).subscribe() 
            //   }, 5000);
            // })
          }

        }, 1000);
      }, error => {
        this.questionService.spinner(false);
        $('#error-modal').modal('show');
        $('.error-text').html(error?.error?.Message);
      });
  }
  initDocsNav(): void {
    var scrollSpy =  (function() {

      var scrollPos;
      var offset;
      var navTargets = [];
  
      function init(nav) {
  
         // offset includes height of fixed nav area
         offset = window.matchMedia('(min-width: 992px)').matches ? $('.breadcrumbs').outerHeight() : $('.layout__sidecol').outerHeight();
  
         // and add 100px as a threshold
         offset += 100;
  
         // store target positions
         $(nav).first().find('li').each(function () {
            var target = $(this).find('a').attr('href');
            if (target === '#') return;
            if ($(target).length) {
  
               let targetPos = Math.floor($(target).offset().top - $('.navbar').outerHeight() - offset - 1)
               if (targetPos < 0) targetPos = 0;
  
               navTargets.push([target, targetPos]);
            }
         });
  
         spy(nav);
      }
  
      function spy(nav) {
         scrollPos = $(window).scrollTop();          
  
         // check each target against scroll position
         navTargets.forEach(function (id, idx) {
  
            // if scroll below target
            if (scrollPos > navTargets[idx][1]) {
  
               // if there is a next target
               if ((idx + 1) < navTargets.length) {
  
                  // check that scroll pos less than next target
                  if (scrollPos < navTargets[idx + 1][1]) {
                     activate(nav, id[0]);
                  }
  
                  // else no further targets, can activate
               } else {
                  activate(nav, id[0]);
               }
  
               // else if target is first item
            } else if (idx == 0) {
               activate(nav, id[0]);
            }
  
         })
      }
  
      function activate(nav, id) {
  
         let $activeLi = $(nav).find('li a[href="' + id + '"]').closest('li');
  
         // activate current li and remove siblings
         $activeLi.addClass('is-spied')
            .siblings('li').removeClass('is-spied')
            .find('li').removeClass('is-spied');
  
         // activate parents if exist and deactivate siblings and children
         let $activeParentLi = $activeLi.closest('ul').closest('li');
         $activeParentLi
            .addClass('is-spied')
            .siblings('li').removeClass('is-spied')
            .find('li').removeClass('is-spied');
      }
      return {
         init: init,
         spy: spy
      };
   })();
    scrollSpy.init('#docs-nav, #docs-nav-mobile');
    $(window).on('scroll.spy', function () { scrollSpy.spy('#docs-nav, #docs-nav-mobile'); });
    $(window).on('resize.spy', function () { scrollSpy.init('#docs-nav, #docs-nav-mobile'); });

    // activate/deactive nav
    $('.central-nav__list li.has-sub > a').on('click', function (e) {
       e.preventDefault();
       $(this).parent('li').toggleClass('is-active')
          .siblings('li').removeClass('is-active');
    });

 }
 initSearch($input): void {
  $.fn.highlight = function (pat, callback) {

    function innerHighlight(node, pat) {
      var skip = 0;
      if (node.nodeType == 3

        // exclusions:
        // text within dropdowns
        && !node.parentNode.closest('.dropdown-menu')
        && !node.parentNode.closest('.dropdown-item')
      ) {
        node.data = node.data.replace(/[\n\r]+/g, ''); // replace new lines
        node.data = node.data.replace(/\s{2,10}/g, ' '); // replace multiple spaces with just 1
        var pos = node.data.toUpperCase().indexOf(pat);
        pos -= (node.data.substr(0, pos).toUpperCase().length - node.data.substr(0, pos).length);
        if (pos >= 0) {
          var spannode = document.createElement('span');
          spannode.className = 'search-hilite';
          var middlebit = node.splitText(pos);
          var endbit = middlebit.splitText(pat.length);
          var middleclone = middlebit.cloneNode(true);
          spannode.appendChild(middleclone);
          middlebit.parentNode.replaceChild(spannode, middlebit);
          skip = 1;
          if (callback) callback();
        }
      }
      else if (node.nodeType == 1 && node.childNodes && !/(script|style)/i.test(node.tagName)) {
        for (var i = 0; i < node.childNodes.length; ++i) {
          i += innerHighlight(node.childNodes[i], pat);
        }

      }

      return skip;
    }


    return this.length && pat && pat.length ? this.each(function () {
      innerHighlight(this, pat.toUpperCase());
    }) : this;

  };

  $.fn.removeHighlight = function () {
    return this.find("span.search-hilite").each(function () {
      const parent = this.parentNode;
      if (parent) {
        parent.replaceChild(this.firstChild as ChildNode, this);
        parent.normalize();
      }
    }).end();
  };

  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop() + $('.navbar').outerHeight();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
  var settings = {
    searchThreshold: 1
  }

  var $searchTrigger = $('#search-trigger, #search-trigger-mobile'),
    $searchContainer = $('#search-container'),
    $inputClear = $('#search-clear'),
    $content = $('#search-body');
  const $searchClose = $('#search-close')

  var result_count = 0,
    curr_result;


  $searchTrigger.off('click').on('click', function (e) {
    e.stopPropagation();

    $searchTrigger.removeClass('is-active');
    $searchContainer.addClass('is-active').closest('.navbar-sub').addClass('search-active');
    $input.focus();

    // listen for outside clicks and close
    $(document).on('click.outsidesearch', function (e) {
      var $target = $(e.target);
      if (!$target.closest(".navbar-sub__search").length && $input.val() == '') {
        resetSearch();
      }
    });

  });

  $inputClear.on('click', function (e) {
    e.preventDefault();
    resetResults();
  });


  $input.on('keyup', function () {

    var search_string = $input.val();
    resetResults();

    // if search bar contains more than x letters
    if (search_string.length > settings.searchThreshold) {

      $content.highlight(search_string, function () {
        result_count++;
      });

      console.log('result count: ' + result_count);

      if (result_count) {
        scrollToResult(1);
      }

    }


  });


  $('.navbar-sub__search-down').on('click', function (e) {
    e.preventDefault();
    goToNextResult();
  });

  $('.navbar-sub__search-up').on('click', function (e) {
    e.preventDefault();
    goToPrevResult();
  });


  $searchClose.on('click', function (e) {
    e.preventDefault();
    resetSearch();
  });


  function goToNextResult() {
    if (curr_result < result_count) {
      scrollToResult(curr_result + 1);
    } else {
      curr_result = 0;
      goToNextResult();
    }
  }

  function goToPrevResult() {
    if (curr_result > 1) {
      scrollToResult(curr_result - 1);
    } else {
      curr_result = result_count + 1;
      goToPrevResult();
    }
  }



  function scrollToResult(resultNo) {

    curr_result = resultNo;

    var $targetEl = $content.find('.search-hilite').eq(resultNo - 1);

    $content.find('.search-hilite').removeClass('is-active');
    $targetEl.addClass('is-active');

    if ($targetEl.isInViewport()) {
      // don't scroll page

      // if not in viewport
    } else {

      if ($targetEl.is(":visible")) {

        let offset = window.matchMedia('(min-width: 992px)').matches ? 50 : $('.layout__sidecol').outerHeight();

        // scroll to target
        $('html, body').scrollTop(
          $targetEl.offset().top - $('.navbar').outerHeight() - offset
        );
      }

    }

  }


  function showNoResults() {
    console.log('no results');
    //$noResults.addClass('is-active');
  }


  function resetResults() {
    result_count = 0;
    $content.removeHighlight();
  }

  function resetSearch() {
    $(document).off('click.outsidesearch');
    $input.val('');
    resetResults();
    $searchTrigger.addClass('is-active');
    $searchContainer.removeClass('is-active').closest('.navbar-sub').removeClass('search-active');
  }

}
  getQuoteSummaryClasses(): any[] {
    return this.quoteSummary?.filter(q => q?.header?.toLowerCase() !== 'policy total' 
    && q?.header?.toLowerCase() !== 'benefits' 
    && q?.header.toLowerCase() !== 'benefits header' 
    && q?.header?.toLowerCase() !== 'item premium subtotal' 
    && q?.header?.toLowerCase() !== 'fees and taxes' 
    && q?.item_id === '0');
  }
  getQuoteTotal(): any[] {
    return this.quoteSummary?.find(q => q?.header?.toLowerCase() == 'policy total')?.premium;
  }
  getQuoteSubTotal(): any[] {
    return this.quoteSummary?.find(q => q?.header?.toLowerCase() == 'item premium subtotal')?.premium;
  }

  getQuoteSummaryClassItems(class_id: any): any[] {
    return this.quoteSummary?.filter(q => q?.header?.toLowerCase() !== 'policy total' 
    && q?.header?.toLowerCase() !== 'benefits' 
    && q?.header.toLowerCase() !== 'benefits header' 
    && q?.header?.toLowerCase() !== 'fees and taxes' 
    && q?.header?.toLowerCase() !== 'item premium subtotal' 
    && q?.class_id === class_id && q?.item_id !== '0');
  }

  getBenefitsForSummary(): any[] {
    return this.quoteSummary?.filter(q => q?.header?.toLowerCase() === 'benefits');
  }
  getBenefits(class_id: number): any[] {
    return this.quoteSummary?.filter(q => q?.header?.toLowerCase() === 'benefits' && q?.class_id === class_id);
  }

  getBenefitsTotal(): string {
    return this.quoteSummary?.find(q => q?.header.toLowerCase() == 'benefits header')?.premium;
  }

  getFeesAndTaxes(): any[] {
    const items = this.quoteSummary?.filter(q => q?.header?.toLowerCase() === 'fees and taxes');
    return items?.find(i => i?.description_1?.toLowerCase() === 'fees')?.premium;
  }
  getTaxes(): any[] {
    const items = this.quoteSummary?.filter(q => q?.header?.toLowerCase() === 'fees and taxes');
    return items?.find(i => i?.description_1?.toLowerCase() === 'taxes')?.premium;
  }
  getFeesAndTaxesTotal(): string {
    const items = this.quoteSummary?.filter(q => q?.header?.toLowerCase() === 'fees and taxes');
    return items?.find(i => i?.description_1?.toLowerCase() === 'total')?.premium;
  }
  getSasria(): string {
    const items = this.quoteSummary?.filter(q => q?.header?.toLowerCase() === 'fees and taxes');
    return items?.find(i => i?.description_1?.toLowerCase() === 'sasria')?.premium;
  }

  getClassItemForTranscripts(class_id: number): any[] {
    return this.classTranscripts?.filter(c => c?.class_id === class_id && c?.header.toLowerCase() === 'item detail');
  }
  getClassWording(class_id: number): any [] {
    return this.classTranscripts?.filter(c => c?.class_id === class_id && c?.header.toLowerCase() === 'class wording');
  }
  getTranscriptForItem(class_id: number, item_id: string): any[] {
    return this.classTranscripts?.filter(c => c?.class_id === class_id && c?.item_id === item_id && c?.header.toLowerCase() === 'item transcript');
  }

  getBenefitsSectionTotal(): string {
    return this.benefitTranscripts?.find(b => b?.header.toLowerCase() === 'benefits header')?.premium;
  }

  getBenefitItemsForTranscript(): any[] {
    return this.benefitTranscripts?.filter(b => b?.header.toLowerCase() === 'vaps detail');
  }

  getBenefitItems(vaps_id: number): any[] {
    return this.benefitTranscripts?.filter(b => b?.vaps_id === vaps_id && b?.header.toLowerCase() === 'vaps item');
  }

  getWordingBenefitItem(vaps_id: number): any {
    return this.benefitTranscripts?.filter(b => b?.vaps_id === vaps_id && b?.header.toLowerCase() === 'vaps wording');
  }

  getTranscriptForBenefitItem(vaps_id: number): any {
    return this.benefitTranscripts?.filter(b => b?.vaps_id === vaps_id && b?.header.toLowerCase() === 'vaps transcript');
  }
  getDatasetNineClassItemTranscript(
    item: string,
    itemDetailDescription1: string
  ): any[] {
    return this.classTranscripts?.filter(
      (itemFilter) =>
        itemFilter.class_name === item &&
        itemFilter.header === 'Item Transcript' &&
        itemFilter.item_id === itemDetailDescription1
    );
  }
  getDatasetTenBenefitsVapsDetail(class_id: number = 0): any[] {
    let arr = [];
    if (class_id !== 0){
      return this.benefitTranscripts?.filter(
        (itemFilter) => itemFilter.header === 'Vaps Detail' && itemFilter.class_id === class_id
      );
    }
    else {
      return this.benefitTranscripts?.filter(
        (itemFilter) => itemFilter.header === 'Vaps Detail'
      );
    }
    
  }     
  scrollToItem(section: string): void {
    this.selectedSection = section;
    const el = document.getElementById(section);

    if (el) {
      el.scrollIntoView({behavior: 'smooth'});
    }
  }

  replaceSpace(value: string): string {
    return value.replace(/\s+/g, '-').toLowerCase();
  }
  getFrequemcy(): string {
    return this.quoteDetails?.frequency_short;
  }
  
  getDisclosureNotice(header: string = ''): any[] {
    if (header) {
      return this.policyPDFDisclosureNotice.filter(
        (itemFilter) => itemFilter.header === header
      );
    }

    const distinctNoticeList: any[] = [];
    this.policyPDFDisclosureNotice.forEach((item) => {
      if (
        !distinctNoticeList?.find((val) => val?.header === item?.header) &&
        item?.header !== this.disclosureNoticeHeaderType.ALWAYS_ON_TOP &&
        item?.header !== this.disclosureNoticeHeaderType.ALWAYS_ON_BOTTOM
      ) {
        distinctNoticeList.push(item);
      }
    });
    return distinctNoticeList;
  }
  pdfPageSplitting(): void {

    const pageHeight = 1430 - 40; // 40 for largest top & bottom element margins
    const footerPadding = 100;


    function checkPageComponentFit(page) {

        // get total height of page components
        const components = page.querySelectorAll('.pdf-page__component');
        let totalComponentsHeight = 0;
        let continueElementHeight =
            page.querySelector('.pdf-page__continued') ? page.querySelector('.pdf-page__continued').offsetHeight : 0;

        const availableHeight = pageHeight - continueElementHeight - footerPadding;


        // loop through compontents to see if they fit on page
        for (let i = 0; i < components.length; i++) {

            // calc component height (including any margins)
            let componentHeight = components[i].offsetHeight + 40; // for largest top & bottom child element margins
            let componentStyles = window.getComputedStyle(components[i]);
            let componentHeightIncludingMargins = componentHeight + parseInt(componentStyles.marginTop) + parseInt(componentStyles.marginBottom);

            totalComponentsHeight += componentHeightIncludingMargins;            

            // if component is too long to fit on page...
            if (totalComponentsHeight > availableHeight) {

                // if the 1st component on page is already too long...
                if (i === 0) {
                    console.log('WARNING: component is too long to fit on page');

                    // if the component contains a table
                    // let's try and split the table up into multiples tables and insert into new pages
                    if (components[i].querySelector('.table-pdf-wrap')) {

                        console.log('...attempting to split table into multiple tables');
                        splitTableToNewPage(components, page, i, componentHeightIncludingMargins, availableHeight);
                        return;

                        // if the component contains an index list
                    } else if (components[i].querySelector('.pdf-index')) {

                        console.log('...attempting to split index into multiple pages');
                        checkIndexPageFit(components[i].querySelector('.pdf-index'));
                        return;

                        // else check how many pages the component would take up and increase height of page accordingly
                        // this is just fallback functionality and should hopefully never occur
                    } else {
                        console.log('...fallback to increase page height');
                        let numPages = Math.ceil(componentHeightIncludingMargins / availableHeight);
                        page.classList.add('pdf-page--pages', 'pdf-page--pages-' + numPages);
                    }
                }

                // if we've made it to the 2nd+ component, split the page
                if (i > 0) {

                    // console.log('split at component #' + i);                  
                    splitComponentsToNewPage(components, page, i);
                    return;
                }


            }

        }

    }


    function splitComponentsToNewPage(components, page, componentIdx) {

        // create new page & move remaining components to new page
        let newPage = document.createElement('section');
        newPage.classList.add('pdf-page');


        // loop through remaining components and add them to new page 
        for (let j = componentIdx; j < components.length; j++) {
            newPage.appendChild(components[j]);
        }

        // add continue header to new page if data-title exists  
        let pageTitle = page.getAttribute('data-title');        
        let componentTitle = components[componentIdx].getAttribute('data-component-title');

        if (pageTitle) {

            newPage.setAttribute('data-title', pageTitle);
            let continuedHeader = document.createElement('div');
            continuedHeader.classList.add('pdf-page__continued');

            if (componentTitle) {
                continuedHeader.innerHTML = '<div><span>' + pageTitle + ' &mdash;</span> ' + componentTitle + ' continued...</div>';
            } else {
                continuedHeader.innerHTML = '<div>' + pageTitle + ' continued...</div>';
            }

            newPage.prepend(continuedHeader);
        }

        // add footer to new page
        let footer = page.querySelector('.pdf-page__footer').cloneNode(true);
        newPage.appendChild(footer);

        page.after(newPage);

        // check new page to see if components fit
        checkPageComponentFit(newPage);

    }


    function splitTableToNewPage(components, page, i, componentHeightIncludingMargins, availableHeight) {

        let table = components[i].querySelector('.table-pdf-wrap');
        let rows = table.querySelectorAll(':not(.cell-nested) tr');

        // calc goal height of table  
        let tableHeight = table.offsetHeight;
        let tableHeightGoal = tableHeight - (componentHeightIncludingMargins - availableHeight);


        // calc number of rows that need to be removed from bottom of table        
        let rowsToRemove = 0;

        let splitIsPossible = true;

        for (let j = rows.length - 1; j >= 0; j--) {
            let rowHeight = rows[j].offsetHeight;
            tableHeight -= rowHeight;
            rowsToRemove++;

            // 1 single row is too high, we need to fail to fallback
            if (rowHeight > tableHeightGoal) {
                splitIsPossible = false;
                console.log('FAIL: single row is too tall to fit on page, fallback to increase page height');
                break;
            }

            if (tableHeight < tableHeightGoal) {
                break;
            }
        }


        if (splitIsPossible) {

            console.log('SUCCESS: table split is possible');

            // create a new table with the rows that need to be removed     
            let newTable = table.cloneNode(true);
            let newTableRows = newTable.querySelectorAll('tr');

            // remove rows from start of cloned table
            for (let k = 0; k < newTableRows.length - rowsToRemove; k++) {
                // leave first row in new table
                if (k > 0) {
                    // console.log('removed: '+k +' from clone')
                    newTableRows[k].remove();
                }
            }

            // remove rows from end of original table & add is-continued class
            table.classList.add('is-continued');
            for (let j = rows.length - rowsToRemove; j < rows.length; j++) {
                // console.log('removed: '+j+ ' from original')
                rows[j].remove();
            }


            // create new component element with new table
            let newComponent = document.createElement('div');
            newComponent.classList.add('pdf-page__component');
            newComponent.appendChild(newTable);

            // append it to the page after the original component
            components[i].after(newComponent);

            // failed to split table ...fallback to increase page height instead
        } else {

            let numPages = Math.ceil(componentHeightIncludingMargins / availableHeight);
            page.classList.add('pdf-page--pages', 'pdf-page--pages-' + numPages);

        }


        // then split the components to a new page
        let updatedComponentArray = page.querySelectorAll('.pdf-page__component');
        splitComponentsToNewPage(updatedComponentArray, page, i + 1);

    }


    function splitIndexPage(page, indexList, indexListHeightGoal) {

        let indexListItems = indexList.querySelectorAll('li.pdf-list__item');
        let indexListHeight = indexList.offsetHeight;

        // calc number of items that need to be removed from bottom of list
        let itemsToRemove = 0;

        for (let i = indexListItems.length - 1; i >= 0; i--) {
            let itemHeight = indexListItems[i].offsetHeight;
            indexListHeight -= itemHeight;
            itemsToRemove++;

            if (indexListHeight < indexListHeightGoal) {
                break;
            }
        }


        // create a new index list with the items that need to be removed     
        let newIndexList = indexList.cloneNode(true);
        let newIndexListItems = newIndexList.querySelectorAll('li.pdf-list__item');

        // remove items from start of cloned list
        for (let j = 0; j < newIndexListItems.length - itemsToRemove; j++) {
            newIndexListItems[j].remove();
        }

        // remove items from end of original list
        for (let k = indexListItems.length - itemsToRemove; k < indexListItems.length; k++) {
            indexListItems[k].remove();
        }


        // create new component element with new index list
        let newComponent = document.createElement('div');
        newComponent.classList.add('pdf-page__component');

        let newIndexListWrap = document.createElement('div');
        newIndexListWrap.classList.add('pdf__index');
        newIndexListWrap.appendChild(newIndexList);
        newComponent.appendChild(newIndexListWrap);

        // append it to the page after the original component
        page.querySelector('.pdf-page__component').after(newComponent);

        // then split the components to a new page
        let updatedComponentArray = page.querySelectorAll('.pdf-page__component');
        splitComponentsToNewPage(updatedComponentArray, page, 1);

    }

    function checkIndexPageFit(indexList) {
        if(indexList === null) return;
        
        let page = indexList.closest('.pdf-page');
        let indexListHeight = indexList.offsetHeight;
        let headerElementHeight = page.querySelector('.pdf__coverhead').offsetHeight || 0;        
        let indexListHeightGoal = pageHeight - footerPadding - headerElementHeight;

        if (indexListHeight > indexListHeightGoal) {
            console.log('WARNING: index page is too long, splitting into multiple pages');
            splitIndexPage(page, indexList, indexListHeightGoal);
        }

    }

    function addPageNumbersAndIndex(pages) {
        let previousTitle = ''; 
        let previousSubTitle = '';    
        
        if (document.querySelector('.pdf-index') === null) return;

        pages.forEach((page, index) => {

            // filter only pages with unique data-title attribute
            // and populate index         
            let pageTitle = page.getAttribute('data-title');
            let pageTitleId = page.getAttribute('id');
            if (pageTitle && pageTitle !== previousTitle) {

                // 
                // build top level index list
                //
                let pageList = document.querySelector('.pdf-index');                
                let pageListItem = document.createElement('li');
                pageListItem.classList.add('pdf-list__item');
                let pageTitleAnchor = '#' + pageTitleId;
                pageListItem.innerHTML = `<div><p><a href="${pageTitleAnchor}">${pageTitle}</a></p><div>p. <span class="pdf-page-index"></span></div></div>`;
                pageList.appendChild(pageListItem);
                previousTitle = pageTitle;
                

                //
                // build sublist index list
                // 

                // find all pages that have the same data-title attribute as current page            
                let pagesWithSameTitle = document.querySelectorAll(`.pdf-page[data-title="${pageTitle}"]`);

                // prepare a sublist wrapper
                let subList = document.createElement('ul');                 

                // find all instances of .pdf-page__component[data-sub-title] within pages with same title
                pagesWithSameTitle.forEach((pageWithSameTitle, index) => {
                    let pageSubTitles = pageWithSameTitle.querySelectorAll('.pdf-page__component[data-sub-title]');

                     // if there are subtitles, add items to the sublist
                    if (pageSubTitles.length > 0) {  
                        
                        pageSubTitles.forEach((subTitle, index) => {
                            let subTitleId = subTitle.getAttribute('id');
                            let subTitleAnchor = '#' + subTitleId;
                            let subTitleText = subTitle.getAttribute('data-sub-title');
                            let subListItem = document.createElement('li');
                            subListItem.classList.add('pdf-list__subitem');
                            subListItem.innerHTML = `<div><p><a href="${subTitleAnchor}">${subTitleText}</a></p><div>p. <span class="pdf-page-index"></span></div></div>`;
                            subList.appendChild(subListItem);
                        });
                    }
                    
                });
                
                // finally, append the subList created above  
                if(subList.children.length > 0) pageListItem.appendChild(subList);
                

            }
        });


        // now we need to check if the index page itself is too long
        // if so, we need to split it into multiple pages
        checkIndexPageFit(document.querySelector('.pdf-index'));

        let allIndexListItems = document.querySelectorAll('.pdf-index li.pdf-list__item');     
        let uniqueIndexItemCount = 0;    
        previousTitle = '';

        // then we gotta loop through the updated page list and add page numbers and index numbers        
        const updatedPages = document.querySelectorAll('.pdf-page:not(.pdf-page--cover)');
        updatedPages.forEach((page, index) => {

            // insert page numbers of into .pdf-page-num elements
            let pageNum = index;
            let pageNumberElements = page.querySelectorAll('.pdf-page-num');
            pageNumberElements.forEach((pageNumberElement, index) => {
                let pageNumString = pageNum < 10 ? '0' + pageNum : pageNum.toString();
                pageNumberElement.innerHTML = pageNumString;
            });

            // filter only pages with unique data-title attribute
            // and add page numbers
            let pageTitle = page.getAttribute('data-title');
            if (pageTitle && pageTitle !== previousTitle) {
                let pageIndexString = index < 10 ? '0' + index : index.toString();
                allIndexListItems[uniqueIndexItemCount].querySelector('.pdf-page-index').innerHTML = pageIndexString;
                previousTitle = pageTitle;
                uniqueIndexItemCount += 1;
            }

        });  


        // add sub-level index numbers        
        let allSubLevelIndexListItems = document.querySelectorAll('.pdf-index li.pdf-list__subitem');

        allSubLevelIndexListItems.forEach((subItem, index) => {
            let anchor = subItem.querySelector('a').getAttribute('href').replace('#', '');
            let anchorEl = document.getElementById(anchor);
            if(anchorEl === null) return;
            let pageWithAnchor = anchorEl.closest('.pdf-page');            
            let subIndexPageNum = parseInt(pageWithAnchor.querySelector('.pdf-page-num').innerHTML);
            let subIndexString = subIndexPageNum < 10 ? '0' + subIndexPageNum : subIndexPageNum.toString();
            subItem.querySelector('.pdf-page-index').innerHTML = subIndexString;
        });




        // loop through all the pages again after page numbers have been allocated and update page references   
        updatedPages.forEach((page, index) => {

            // find all .pdf-page-x class elements on each page and populate with page number
            let pageRefElements = page.querySelectorAll('.pdf-page-x');
            if (!pageRefElements) return;

            pageRefElements.forEach((pageRefElement, index) => {
                let pageRefElementTarget = pageRefElement.getAttribute('data-target');

                // find page number that contains target element
                let targetTitleEl = document.getElementById(pageRefElementTarget);
                if (!targetTitleEl) return;
                let targetPage = targetTitleEl.closest('.pdf-page');

                // find page number element within target page
                let targetPageNum = targetPage.querySelector('.pdf-page-num').innerHTML;

                // update page reference element with page number
                pageRefElement.innerHTML = targetPageNum;

            });

        });


        



        // handle anchor clicks
        document.querySelectorAll('.pdf-index a').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                let target = document.querySelector(this.getAttribute('href'));

                // create new element within target and scroll to that instead
                let scrollTarget = document.createElement('div');
                scrollTarget.classList.add('pdf-page__scroll-target');
                target.prepend(scrollTarget);

                scrollTarget.scrollIntoView({
                    behavior: 'smooth'
                });

                // remove the scroll target after 1 second
                setTimeout(() => {
                    scrollTarget.remove();
                }, 1000);
            });
        });


    }

    function splitLegalRows(table, row, rowHeightMax) {

        let legalCell = row.querySelector('.cell-legal');

        // get number of elements within legalCell
        let legalCellElements = legalCell.querySelectorAll(':scope > *');

        // calc number of elements that need to be removed from cell to fit within rowHeightMax
        let elementsToRemove = 0;
        let legalCellHeight = legalCell.offsetHeight;

        for (let i = legalCellElements.length - 1; i >= 0; i--) {
            let elementHeight = legalCellElements[i].offsetHeight;
            legalCellHeight -= elementHeight;
            elementsToRemove++;

            if (legalCellHeight < rowHeightMax) {
                break;
            }
        }

        let rowClone = row.cloneNode(true);
        let legalCellClone = rowClone.querySelector('.cell-legal');

        // remove elements from end of original cell
        for (let j = legalCellElements.length - elementsToRemove; j < legalCellElements.length; j++) {
            legalCellElements[j].remove();
        }

        // remove elements from start of cloned cell  
        let legalCellCloneElements = legalCellClone.querySelectorAll(':scope > *');
        for (let k = 0; k < legalCellCloneElements.length - elementsToRemove; k++) {
            legalCellCloneElements[k].remove();
        }

        // empty .cell-legal-num cells in cloned row        
        rowClone.querySelectorAll('.cell-legal-num').forEach((cellLegalNum, index) => {
            cellLegalNum.innerHTML = '';
        });

        // append rowClone to table
        row.after(rowClone);

        // repeat until rowClone is less than rowHeightMax
        if (rowClone.offsetHeight > rowHeightMax) splitLegalRows(table, rowClone, rowHeightMax);

    }

    function checkLegalTablesFit(legalTables) {

        const rowHeightMax = pageHeight - 405; // 1430 - 405 = 1025

        // with each legal table
        legalTables.forEach((table, index) => {

            let rows = table.querySelectorAll('tr');

            // check if any rows are higher than rowHeightMax
            let rowTooHigh = false;
            rows.forEach((row, index) => {
                if (row.offsetHeight > rowHeightMax) {
                    console.log('WARNING: legal table row is too high, splitting cell elements...');
                    splitLegalRows(table, row, rowHeightMax);
                }
            });


        });

    }



    // PDF page splitting etc..
    let legalTables = document.querySelectorAll('.table--pdf-legal');
    checkLegalTablesFit(legalTables);

    let pages = document.querySelectorAll('.pdf-page:not(.pdf-page--cover)');
    pages.forEach((page, index) => {
      checkPageComponentFit(page);
    });

    const allCountedPages = document.querySelectorAll(
      '.pdf-page:not(.pdf-page--cover)'
    );
    addPageNumbersAndIndex(allCountedPages);


  }
  printPDF(): void {
    const element = document.getElementById('search-body');
    this.questionService.pdf(element.innerHTML,'',false,0,'','print_pdf_v1', 'bundle_v1').subscribe(resp => {
      let id = resp.replace('https://vader.everything.insure/pdf/files/','');
      const isNative = this.device?.platform && this.device.platform !== 'web';
      if (isNative) {
        Browser.open({ url: resp.toString() });
        this.clearProcessingAlert();
      } else {
        this.openPDFPreview(resp.toString());
      }
      setTimeout(() => {
        this.questionService.pdf('',id).subscribe()
      }, 5000);
    })
  }
  openPDFPreview(url: string): void {
    if (this.previewObjectUrl) {
      URL.revokeObjectURL(this.previewObjectUrl);
      this.previewObjectUrl = null;
    }
    this.httpClient.get(url, { responseType: 'blob' }).subscribe(blob => {
      this.previewObjectUrl = URL.createObjectURL(blob);
      this.previewFileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewObjectUrl);
      $('#modal-pdf-preview').modal('show');
    });
  }
  onPdfIframeLoad(): void {
    this.clearProcessingAlert();
  }
  clearProcessingAlert(): void {
    this.processingAlert?.clear?.();
    this.processingAlert = null;
  }
  preparePDF(): void {
    this.questionService.spinner(true);
    this.pdfDoc = true;
    document.querySelector('body')?.classList.add('page--pdf');
    document.querySelector('body')?.classList.remove('page--pdf-view');
    document.querySelector('body')?.classList.remove('page--central');
  }
  // fires once the print stylesheet the (pdfDoc) @if block just created has actually
  // loaded — calling initPDFStuff() straight after the flag flip races the browser's
  // fetch/parse of that <link>, so heights get measured under the pre-print layout.
  onPrintCssLoaded(): void {
    this.questionService.initPDFStuff();
    this.processingAlert = Alert("Processing... please wait", 30000);
    this.questionService.spinner(false);
    this.printPDF();
  }
  constructID(title: string): string {
    return `anchor-${title.replace(/ /g,'-')
      .replace(/\//g, "-")
      .replace(/&/g, "-")
      .replace(/\+\./g, "-")
      .toLowerCase()}`;
  }
  getDatasetNineClassItemDetail(item: string): any[] {
    return this.classTranscripts.filter(
      (itemFilter) =>
        itemFilter.class_name === item && itemFilter.header === 'Item Detail'
    );
  }
  getImageForClass(item: string): string {
    return this.classTranscripts?.find(
      (itemFilter) =>
        itemFilter.header === 'Class Header' && itemFilter.class_name === item
    )?.img_path;
  }
  getClasses(): any[] {
    let arr = [];
    this.quoteSummary.forEach(v => {
      if (arr.filter(e => e.class_name === v?.class_name).length === 0 && v?.class_name ) {
        arr.push(v)
      }
    });
    return arr;
   }
   getVapClasses(): any[] {
    let arr = [];
    this.benefitTranscripts.forEach(v => {
      if (arr.filter(e => e.class_name === v?.class_name).length === 0 && v?.class_name ) {
        arr.push(v)
      }
    });
    return arr;
   }
   getDatasetTenBenefitsVapsWordingByClass(class_id: number): any[] {
    return this.benefitTranscripts?.filter(
      (itemFilter) =>
        itemFilter.header === 'Vaps Wording' && itemFilter.class_id === class_id
    );
  }
  checkIfVapsWordingExists(): any {
    return this.benefitTranscripts?.filter(
      (itemFilter) =>
        itemFilter.header === 'Vaps Wording'
    );
  }
  getDatasetTenBenefitsVapsItems(class_id: number): any[] {
    return this.benefitTranscripts?.filter(
      (itemFilter) =>
        itemFilter.header === 'Vaps Item' && itemFilter.class_id === class_id
    );
  }
  getDatasetTenBenefitsVapsWording(vapsId: number): any[] {
    return this.benefitTranscripts?.filter(
      (itemFilter) =>
        itemFilter.header === 'Vaps Wording' && itemFilter.vaps_id === vapsId
    );
  }
  getDatasetNineClassItemWording(
    item: string,
    item_id: string
  ): any[] {
    
    return this.classTranscripts.filter(
      (itemFilter) =>
        itemFilter.class_name === item &&
        itemFilter.header === 'Item Wording' &&
        itemFilter.item_id === item_id
    );
  }
  getDatasetNineClassWording(item: string): any[] {
    return this.classTranscripts.filter(
      (itemFilter) =>
        itemFilter.class_name === item && itemFilter.header === 'Class Wording'
    );
  }
  ngOnDestroy(): void {
    if (this.previewObjectUrl) {
      URL.revokeObjectURL(this.previewObjectUrl);
    }
  }
}
